import { render } from "./SidebarPositionEditor.vue?vue&type=template&id=6a54bad2"
import script from "./SidebarPositionEditor.vue?vue&type=script&lang=js"
export * from "./SidebarPositionEditor.vue?vue&type=script&lang=js"

import "./SidebarPositionEditor.vue?vue&type=style&index=0&id=6a54bad2&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__